import { forwardRef, type SVGProps } from 'react';

export type SearchProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const Search = forwardRef<SVGSVGElement, SearchProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M21 21.06l6.49 6.49M14.15 4.8a9.4 9.4 0 109.4 9.4 9.4 9.4 0 00-9.4-9.4z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
));
Search.displayName = 'Search';
